import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
}

export const Portal = ({ children }: PortalProps) => {
  return typeof document === 'object'
    ? createPortal(children, document.body)
    : null;
};
